<template>
  <div class="">
    <Breadcrumb :title="$t('miga.SelectQueue')" />
    <HeadingBox
      :title="$t('selectqueue.title')"
      :description="$t('selectqueue.description')"
    />
    <DatosIntroducidos />
    <ListBox :items="queues" :loading="loading" title="name"  :icons="['fa fa-building']" :onSelect="onSelect" :heading="$t('selectqueue.title')" :titleWeight=400 />
  </div>
</template>
<script>
import Vue from 'vue';
import HeadingBox from "../components/HeadingBox";
import Breadcrumb from "../components/Breadcrumb";
import DatosIntroducidos from "../components/DatosIntroducidos";
import ListBox from "../components/ListBox";

import APIPortal from "@/services/APIPortal.js";
import Session from "@/session/Session.js";

export default {
  name: "SelectQueue",

  components: {
    HeadingBox,
    Breadcrumb,
    DatosIntroducidos,
    ListBox,
  },
  data: () => ({
    tenant: Session.getTenant(),
    loading: false,
    queues: [],
  }),
  beforeDestroy() {
    window.removeEventListener('language.changed', this.init);
  },
  async mounted() {
    window.addEventListener("language.changed", () => Vue.nextTick(this.init));
    this.init();
  },
  methods: {
    async init() {
      this.queues.splice(0, this.queues.length)
      this.loading = true
      let res = await APIPortal.queuesByTenant(this.tenant.id, "m");
      this.loading = false
      this.queues = window._.chain(res.data|| []).filter(q => q.enabled).sortBy(['name']).value();
    },
    onSelect(q) {
      window.console.log("onSelect>", q);
      Session.setTenant(this.tenant);
      Session.setQueue(q);
      this.$router.push({ name: 'SelectService' });
    },
  },
};
</script>

<style scoped>
.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
